import 'bootstrap/dist/css/bootstrap.min.css';
import {
  DisplayItemAttribute,
  getCustomersOptionsFromOrders,
  getPaymentOptionsFromOrders,
  getSellersOptionsFromOrders,
  getShiftsOptionsFromOrders,
} from '../functions/order_functions';
import {
  ArchivedOrdersWrapper,
  ExpandedOrderWrapper,
  FilterBtnsStyled,
} from './archived_orders_components.styled';
import { ArrowRight } from 'react-bootstrap-icons';

import { Table } from 'antd';
import { DatePicker } from 'antd';
import ReactSelect from 'react-select';

import { ListingItem } from '../../../data/types/listings';
import { externalLinkIcon_path } from '../../../assets/index';
import {
  OrderBrief,
  OrderDetails,
  OrderItemBrief,
  OrderItemDetailed,
} from '../../../data/types/orders';
import { AttributeAssociation } from '../../../data/types/listings';
import Button from '../../../components/buttons';
import { Button as NextButton } from '@nextui-org/react';
import { Colors } from '../../../config/theme';
import ShowImage from '../../../components/show_image';
import { DateTimeFormatDateOnly } from '../../../config/constants';
import Spinner from '../../../components/spinner';
import {
  formatDecimals,
  formatPrice,
} from '../../../utils/functions/formatting_functions';
import { TiArrowRightOutline } from 'react-icons/ti';
import { AttributeType } from '../../../data/types/attributes';
import { useEffect, useState } from 'react';
import { OrdersApiRepository } from '../../../data/repositories/orders_repository';
import { IoLinkOutline } from 'react-icons/io5';
import Lightbox from 'react-image-lightbox';
const { RangePicker } = DatePicker;

export const OrderItemBriefCard = ({
  item,
  openListingDetailsFunction,
}: {
  item: OrderItemBrief;
  openListingDetailsFunction: (listingId: number) => void;
}) => {
  const getItemCharacteristics = (item: ListingItem) => {
    if (item.attributes.length) {
      return item.attributes?.map((attr, i) => {
        return (
          <div key={i} className="item text-center">
            <div className="item-element-name">
              {attr.attr_name_en + ' | ' + attr.attr_name_ar}
            </div>
            <div className="item-element">
              <DisplayItemAttribute attribute={attr} />
            </div>
            {/* <div className="item-element-value">{attr.attr_value}</div> */}
          </div>
        );
      });
    } else {
      return <></>;
    }
  };
  return (
    <ArchivedOrdersWrapper>
      <div className="p-2 order-item-card">
        <div className="row">
          <div className="col-md-2">
            <ShowImage
              image={item.item.image}
              style={{
                width: '70px',
                height: '70px',
              }}
            />
          </div>
          <div className="col-md-10">
            <div className="row">
              <div className="col-md-12 m-2">
                <span className="title">{item.item.name_en}</span>{' '}
                {/* TODO: localize */}
              </div>
              <div className="col-md-12 mt-2 item-container">
                {getItemCharacteristics(item.item)}
              </div>
              <div className="col-md-12 mt-2 between">
                <span className="value ">
                  <span className="qty ">{item.quantity}</span>{' '}
                  <span className="mx-2 qty">x</span>{' '}
                  <span className="amount">{formatPrice(item.item.price)}</span>
                </span>
                <ArrowRight
                  size={'20px'}
                  style={{ cursor: 'pointer' }}
                  onClick={() =>
                    openListingDetailsFunction(item.item.listing_id)
                  }
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </ArchivedOrdersWrapper>
  );
};

// Accept orderDetail and other props directly in the component
export const OrderArchiveExpandedComponent = ({
  orderId,
  storeId,
  openOrderDetailsFunction,
  ordersRepository,
  openListingDetailsFunction,
}: {
  storeId?: number;
  orderId: number;
  ordersRepository: OrdersApiRepository;
  openOrderDetailsFunction: (orderId: number) => void;
  openListingDetailsFunction: (listingId: number) => void;
}) => {
  const [orderDetail, setOrderDetail] = useState<OrderDetails | undefined>();
  const [loader, setLoader] = useState<boolean>(true);

  const [image, setImage] = useState<any>();

  useEffect(() => {
    getOrderDetails();
  }, [orderId]);

  const getOrderDetails = async () => {
    setLoader(true);
    await ordersRepository
      .getOrderDetailsByID({
        order_id: orderId,
        store_id: storeId,
      })
      .then((res: any) => {
        if (!res) return;
        setOrderDetail(res as OrderDetails);
      });
    setLoader(false);
  };

  const columns = [
    {
      title: 'Item Name',
      dataIndex: 'name_en',
      key: 'name_en',
      render: (_: string, record: OrderItemDetailed) => (
        <div className="content">
          <ShowImage
            image={record.item.image}
            onClick={() => setImage(record.item.image)}
            style={{
              width: '70px',
              height: '70px',
              objectFit: 'scale-down',
              borderRadius: '5px',
            }}
          />
          <p className="d-flex align-content-center">
            {record.listing.name_en} | {record.listing.name_ar}
          </p>
        </div>
      ),
    },
    {
      title: 'Quantity',
      dataIndex: 'quantity',
      key: 'quantity',
    },
    {
      title: 'Customizations',
      dataIndex: 'customizations',
      key: 'customizations',
      render: (_: any, record: OrderItemDetailed) =>
        record.item.attributes
          ?.map((attr: AttributeAssociation) =>
            attr.attribute_type === AttributeType.NUMERIC
              ? formatDecimals(attr.attr_value_en?.toString()) + ' ' + attr.unit
              : attr.attr_value_en,
          )
          .join(', '),
    },
    {
      title: 'Item ID',
      dataIndex: 'id',
      key: 'id',
      render: (_: any, record: OrderItemDetailed) => record.item.id,
    },
    {
      title: 'In Stock',
      dataIndex: 'in_stock',
      key: 'in_stock',
      render: (_: any, record: OrderItemDetailed) =>
        record.item.in_stock ? 'Available' : 'Sold Out',
    },
    {
      title: 'Price',
      dataIndex: 'unit_price',
      key: 'unit_price',
      render: (_: any, record: OrderItemDetailed) =>
        formatPrice(record.unit_price),
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_: any, record: OrderItemDetailed) => (
        <NextButton
          startContent={<IoLinkOutline />}
          color="success"
          variant="light"
          onClick={() => openListingDetailsFunction(record.item.listing_id)}
        >
          View Listing
        </NextButton>
      ),
    },
  ];

  return (
    <>
      {image && (
        <Lightbox
          mainSrc={image.public_s3_url}
          imageTitle={`# ${image.id} ` + (image.alt || 'No Alt Text')}
          mainSrcThumbnail={image.public_s3_url}
          onCloseRequest={() => {
            setImage(undefined);
          }}
        />
      )}
      <ExpandedOrderWrapper>
        {loader ? (
          <Spinner />
        ) : (
          <div
            style={{
              display: 'flex',
            }}
          >
            <Table
              columns={columns}
              className="flex-grow-1"
              dataSource={orderDetail?.items}
              pagination={false}
              // rowKey={(record: OrderDetails) => record.item.id}
            />
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'end',
                width: '75px',
                backgroundColor: Colors.greenMain,
                padding: '5px',
              }}
            >
              <Button
                text="View Order Details"
                onClick={() => openOrderDetailsFunction(orderDetail!.id)}
                bg="transparent"
                color={Colors.white}
                style={{
                  fontSize: '14px',
                }}
              />
              <TiArrowRightOutline
                size={20}
                color="white"
                style={{ cursor: 'pointer' }}
              />
            </div>
          </div>
        )}
      </ExpandedOrderWrapper>
    </>
  );
};

type FilterBtnProps = {
  orders: OrderBrief[];
  filters: any;
  setFilters: any;
};
export const FilterBtns = ({ orders, filters, setFilters }: FilterBtnProps) => {
  const handleDates = (e: any) => {
    // TODO fix any
    setFilters({
      ...filters,
      date: e,
    });
  };
  return (
    <FilterBtnsStyled>
      <div className="filter">
        <label className="">Date range</label>
        <RangePicker
          format={DateTimeFormatDateOnly}
          onChange={(date: any) => handleDates(date)}
          style={{ height: '40px', borderRadius: '5px' }}
        />
      </div>
      <div className="filter">
        <label className="">Delivery Type</label>
        <ReactSelect
          placeholder="All"
          options={[{ label: 'Delivery ', value: 'Delivery' }]}
        />
      </div>
      <div className="filter">
        <label className="">Payment method</label>
        <ReactSelect
          placeholder={
            filters?.transaction_method?.length === 1
              ? filters.customers[0]?.toString()
              : 'All'
          }
          isMulti={true}
          onChange={(val) =>
            setFilters({
              ...filters,
              transaction_method: val.map((item) => item.value),
            })
          }
          options={getPaymentOptionsFromOrders(orders)}
        />
      </div>
      <div className="filter">
        <label className="">Customer ID</label>
        <ReactSelect
          placeholder={
            filters?.customers?.length === 1
              ? filters.customers[0]?.toString()
              : 'All'
          }
          isMulti={true}
          onChange={(val) =>
            setFilters({
              ...filters,
              customers: val.map((item) => item.value),
            })
          }
          options={getCustomersOptionsFromOrders(orders)}
        />
      </div>
      <div className="filter">
        <label className="">Store ID</label>
        <ReactSelect
          placeholder={
            filters?.sellers?.length === 1
              ? filters.sellers[0]?.toString()
              : 'All'
          }
          isMulti={true}
          onChange={(val) =>
            setFilters({
              ...filters,
              sellers: val.map((item) => item.value),
            })
          }
          options={getSellersOptionsFromOrders(orders)}
        />
      </div>
      <div className="filter">
        <label className="">Shift ID</label>
        <ReactSelect
          placeholder={
            filters?.shifts?.length === 1
              ? filters.shifts[0]?.toString()
              : 'All'
          }
          isMulti={true}
          onChange={(val) =>
            setFilters({
              ...filters,
              shifts: val.map((item) => item.value),
            })
          }
          options={getShiftsOptionsFromOrders(orders)}
        />
      </div>
    </FilterBtnsStyled>
  );
};
